module.exports = __webpack_public_path__ + "media/images/app/products/rings_orange_candies-66da5a259f461026bd3075f19b2779a1.webp";